package com.essntl.features.itinerary.ui.send_message.components

import androidx.compose.foundation.layout.*
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.style.TextAlign
import com.essntl.uikit.components.button.primary.EsLargePrimaryButton
import com.essntl.uikit.components.dialog.EsDialog
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography

@Composable
fun EssntlDemoPopup(
    isOpen: Boolean,
    onDismissRequest: () -> Unit,
) {
    if (isOpen) {
        EsDialog(
            title = "Odia Demo",
            onDismissRequest = onDismissRequest,
        ) {
            Column(
                modifier = Modifier.padding(2.5.spacing),
            ) {
                Text(
                    text = "This feature is disabled in the demo version",
                    textAlign = TextAlign.Start,
                    style = MaterialTheme.esTypography.p1Regular16.copy(
                        color = MaterialTheme.esColorScheme.textPrimary,
                    ),
                    modifier = Modifier.padding(horizontal = 2.5.spacing),
                )

                Spacer(modifier = Modifier.height(3.spacing))

                EsLargePrimaryButton(
                    text = "OK",
                    onClick = onDismissRequest,
                    modifier = Modifier.fillMaxWidth(),
                )
            }
        }
    }
}